import {
  LIVE_STREAMING,
  LIVE_STREAMING_SUCCESS,
  LIVE_STREAMING_FAILURE,
  DELETE_EVENT_SUCCESS,
  DELETE_EVENT_FAILURE,
  END_EVENT,
  END_EVENT_SUCCESS,
  END_EVENT_FAILURE,
  SEND_EVENT_NOTIFICATION,
  SEND_EVENT_NOTIFICATION_SUCCESS,
  SEND_EVENT_NOTIFICATION_FAILURE,
} from "../constants";

const initialState = {
  isLoading: false,
  liveStreams: [],
  count: 0,
  deleted: 0,
  pagination: {},
  error: null,
};

export default function LiveReducer(state = initialState, action) {
  switch (action.type) {
    case LIVE_STREAMING:
      state = {
        ...state,
        isLoading: true,
      };
      break;
    case LIVE_STREAMING_SUCCESS:
      console.log(action.payload?.data, "liveeeee");

      state = {
        ...state,
        isLoading: false,
        count: action.payload.total,
        liveStreams: action.payload.data,
        pagination: action.payload.paginate,
        deleted: action.payload.deleted,
      };
      break;
    case LIVE_STREAMING_FAILURE:
      state = {
        ...state,
        isLoading: false,
        error: action.payload,
      };
      break;
    case DELETE_EVENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload || "Something went wrong",
      };

    case DELETE_EVENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        liveStreams: state.liveStreams.filter(
          (stream) => stream.id !== action.payload
        ),
        count: state.count - 1,
      };
    case END_EVENT:
      state = {
        ...state,
        isLoading: true,
      };
      break;
    case END_EVENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        liveStreams: state.liveStreams.filter(
          (stream) => stream.id !== action.payload
        ),
        count: Math.max(0, state.count - 1),
      };
    case END_EVENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload || "Something went wrong",
      };

    case SEND_EVENT_NOTIFICATION:
      return {
        ...state,
        isLoading: true,
      };

    case SEND_EVENT_NOTIFICATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };

    case SEND_EVENT_NOTIFICATION_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    default:
      break;
  }

  return state;
}
